/* src/app/modules/display/components/menus/product-menu/building-blocks/menu-item/product-section-item-expanded-product-info/product-section-item-expanded-product-info.component.scss */
::ng-deep .force-italic-style * {
  font-style: italic !important;
}
/*# sourceMappingURL=product-section-item-expanded-product-info.component.css.map */
